import { TextInput, NumericInput, BooleanInput, MultipleChoiceInput } from './QuestionInputs';

/**
 * Single question display component
 */
export const QuestionDisplay = ({ 
  question, 
  index, 
  currentAnswers, 
  savingAnswers, 
  isConsultant, 
  sessionStatus,
  onAnswerChange 
}) => {
  const answer = currentAnswers[question.id];
  const saving = savingAnswers[question.id];
  const isActive = sessionStatus === 'active';

  return (
    <div className="border border-gray-200 dark:border-gray-700 rounded-lg p-4 hover:border-emerald-300 dark:hover:border-emerald-600 transition-colors">
      <div className="flex items-start gap-4">
        <div className="flex-shrink-0 w-8 h-8 bg-emerald-100 dark:bg-emerald-900/50 text-emerald-700 dark:text-emerald-300 rounded-full flex items-center justify-center font-semibold text-sm">
          {index + 1}
        </div>
        <div className="flex-1">
          <div className="flex items-start justify-between mb-2">
            <div className="flex-1">
              <p className="font-medium text-gray-900 dark:text-gray-100 mb-1">{question.text}</p>
              <div className="flex items-center gap-2 text-xs text-gray-500 dark:text-gray-400">
                <span className="px-2 py-1 bg-gray-100 dark:bg-gray-700 rounded">
                  {question.category}
                </span>
                <span className="px-2 py-1 bg-blue-100 dark:bg-blue-900/50 text-blue-700 dark:text-blue-300 rounded">
                  {question.type}
                </span>
              </div>
            </div>
          </div>
          
          {/* Answer Input Fields */}
          {isActive && (
            <div className="mt-3 space-y-3">
              {/* Text/Textarea Input */}
              {(question.type === 'text' || question.type === 'textarea') && (
                <TextInput
                  questionId={question.id}
                  value={answer?.answer}
                  onChange={onAnswerChange}
                  placeholder={isConsultant ? "Waiting for user's answer..." : "Enter your answer..."}
                  disabled={isConsultant}
                  saving={saving}
                />
              )}
              
              {/* Numeric Input */}
              {(question.type === 'numeric' || question.type === 'number') && (
                <NumericInput
                  questionId={question.id}
                  value={answer?.answer_numeric}
                  onChange={onAnswerChange}
                  placeholder={isConsultant ? "Waiting for user's answer..." : "Enter numeric value..."}
                  disabled={isConsultant}
                  saving={saving}
                />
              )}
              
              {/* Boolean/Yes-No Input */}
              {(question.type === 'boolean' || question.type === 'yes_no') && (
                <BooleanInput
                  questionId={question.id}
                  question={question}
                  value={answer?.answer}
                  onChange={onAnswerChange}
                  disabled={isConsultant}
                  saving={saving}
                />
              )}
              
              {/* Multiple Choice Input */}
              {(question.type === 'multiple_choice' || question.type === 'select') && question.options && question.options.length > 0 && (
                <MultipleChoiceInput
                  questionId={question.id}
                  options={question.options}
                  value={answer?.answer}
                  onChange={onAnswerChange}
                  disabled={isConsultant}
                  saving={saving}
                />
              )}
              
              {/* Saving Indicator */}
              {saving && (
                <div className="flex items-center gap-2 text-sm text-gray-500 dark:text-gray-400">
                  <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-emerald-500 dark:border-emerald-400"></div>
                  <span>Saving...</span>
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

